



















































import { Component, Prop, namespace, Watch, Ref } from 'nuxt-property-decorator'
import cloneDeep from 'lodash/cloneDeep'
import TreeModel from './tree-model'
import { Experience } from '~/types/experience'

import TreeNode = Experience.TreeNode
import UrlQuery = Experience.UrlQuery

const experience = namespace('experience')

@Component
export default class CategoryLayout extends TreeModel {
  @Prop({ required: true, default: () => [] }) categoryData!: []
  @Prop() searchCategoryData!: TreeNode[]
  @Prop({ default: false }) showSearchLayout!: boolean
  @Prop({ default: false }) inModal!: boolean
  @experience.Action setUrlQuery!: Function
  @experience.Action setSelectedCategory!: Function
  @experience.State pageType!: string
  @experience.State urlQuery!: UrlQuery
  @Ref() ul!: Vue
  category: TreeNode[] = []
  flatCategoryData: any = {}
  // 埋点相关
  get spm() {
    const spm = `DestinationFilter?trg=manual&ext=${JSON.stringify({
      country_id: this.urlQuery.country_ids,
      city_id: this.urlQuery.city_ids
    })}`
    return spm
  }

  @Watch('categoryData')
  categoryDataChange() {
    this.category = cloneDeep(this.categoryData)
    this.flatCategoryData = this.flatChildrenLevel(this.category)
    // 修正父节点不勾选的情况
    this.fixParentNodeChecked(this.category, 'category')
  }

  setCategoryData() {
    const obj: any = {}
    this.category.forEach((category: TreeNode) => {
      if (category.checked) {
        obj[category.id] = category
      } else if (category.children) {
        category.children.forEach((child: TreeNode) => {
          child.checked && (obj[child.id] = child)
        })
      }
    })
    return obj
  }

  async change() {
    const obj = this.setCategoryData()
    if (this.inModal) {
      this.$emit('change', {
        selected: obj,
        category: this.category
      })
      return null
    }
    this.setSelectedCategory(JSON.parse(JSON.stringify(obj)))
    const category = Object.keys(obj).join(',')

    await this.setUrlQuery({
      frontend_id_list: category,
      page: 1
    })

    // todo 暂时屏蔽 ga 的上报，待组件库完善功能后再上
    // this.checkGtm(node, isCheck)
    if (this.inModal) {
      return null
    }
    const moduleTree = document.querySelector('.js-category-layout-spm') as HTMLElement
    this.$inhouse.updateBinding(moduleTree, {
      ext: JSON.stringify({ categorytree_id: category })
    })
    this.$inhouse.track('action', this.ul.$el)
  }

  checkGtm(node: TreeNode, isCheck: boolean) {
    if (isCheck) {
      const id = node.id
      const content = this.pageType === 'search'
        ? `Experience SearchResult|ExperienceSearchResult_Categroy_Clicked|levei_${id}`
        : `Experience Category|ExperienceCategory_Categroy_Clicked|levei_${id}`
      this.$sendGTMCustomEvent(content)
    }
  }

  // 监听checkbox勾选事件
  handleCheckboxSelect(isChecked: boolean, item: TreeNode): void {
    // 两个容器的数据需要同步，否则就会导致显示有误，
    // 1、点击search结果展示页的checkbox ，先获取两个容器中该数据的子节点是否一致，如果不一致，就将全选的数据
    // 和正常展示页面的数据，进行对比，然后勾选/取消
    // 2、操作normal数据，只需要同步到父组件的_backupCategoryData数据中即可
    const flag = this.showSearchLayout
    const { children, id } = item
    if (flag) {
      // 操作this.searchCategory
      // 1.先将子节点勾选
      if (children?.length) {
        children.forEach((child: TreeNode) => {
          this.$set(child, 'checked', isChecked)
        })
        // 2. 获取item 内children节点的内容，
        this.getSameLevelData(id, isChecked, children)
      }
    } else {
      // 操作this.category
      // 1.先勾选子节点
        children?.length && children.forEach((child: TreeNode) => {
        this.$set(child, 'checked', isChecked)
      })
    }
    // 2. 同步this.category中的数据到父组件的_backupCategoryData
    this.$emit('categoryDataChange', this.category)
    this.change()
  }

  // 获取this.ranges 中和 this.searchRangeData中数据相同的节点
  getSameLevelData(id: any, isChecked: boolean, children?: TreeNode[]) {
    const matchContent: any = this.flatCategoryData[id]
    if (children === undefined) {
      // 如果没有子节点，默认勾选所有节点
      [matchContent, ...matchContent.children].forEach((item: TreeNode) => {
        this.$set(item, 'checked', isChecked)
      })
    } else {
      this.replceCategoryData(isChecked, children, matchContent)
    }
    this.$emit('categoryDataChange', this.category)
  }

  // 注意点： 这里不能直接替换children的内容，因为过滤的节点 <= 原始节点
  replceCategoryData(isChecked: boolean, source: TreeNode[], target: TreeNode): void {
    // 1、先判断过滤的节点包含的子元素和this.categories中该节点的子元素长度是否一致
    // a: 如果一致,直接替换国家节点的children属性
    if (target.children && source.length === target.children.length) {
      this.$set(target, 'children', source)
      this.$set(target, 'checked', isChecked)
    } else {
      // b: 如果不一致，先获取source数据的id，然后去this.flatCategoryData中获取对应的节点，修改属性即可
      ;(source || []).forEach((_source: TreeNode) => {
        const { id } = _source
        const content = this.flatCategoryData[id]
        content && (this.$set(content, 'checked', isChecked))
        // 注意点: 被设置之前是否父节点是否已经是全选，在isChecked是false的情况下，需要修改父节点的勾选情况
        !isChecked && this.$set(target, 'checked', false)
      })
    }
  }

  /**
   * 每个城市点击的事件
   * 选中：校验是否满足勾选checkbox的条件；
   * 取消：校验是否是全选，如果是全选且是取消操作，就取消勾选checkbox
   **/
  handleItemClick(item: any, parent: any) {
    const searchFlag = this.showSearchLayout
    let checked: boolean = false // 默认为false，赋值后在重新取一次
    const { checked: parentChecked, id: parentId } = parent
    const cacheParentContent = this.flatCategoryData[parentId]
    this.$set(item, 'checked', !item.checked)
    checked = item.checked

    if (searchFlag) {
      const { id } = item
      const cacheItemContent = this.flatCategoryData[id]
      this.$set(cacheItemContent, 'checked', checked)
    }

    if (checked) {
      const flag: boolean = this.validateNeedSelectCheckbox(parent.children)
      flag && (this.$set(parent, 'checked', true))
      // 这里不能直接勾选this.ranges的数据，过滤节点数量 <= 非过滤节点
      if (searchFlag) {
        const rangeParentFlag: boolean = this.validateNeedSelectCheckbox(cacheParentContent.children)
        rangeParentFlag && this.$set(cacheParentContent, 'checked', true)
      }
    } else if (parentChecked && !checked) {
      // 取消这里，无需校验，肯定是直接取消的
      this.$set(parent, 'checked', false)
      searchFlag && this.$set(cacheParentContent, 'checked', false)
    }

    // 注意点，过滤的节点，如果只有一个节点，且节点是被勾选的情况下，需要勾选父节点的checkbox(已修正)
    this.$emit('categoryDataChange', this.category)

    this.change()
  }

  mounted() {
    this.category = cloneDeep(this.categoryData)
    this.fixParentNodeChecked(this.category, 'category')
    this.$emit('categoryDataChange', this.category)
    this.flatCategoryData = this.flatChildrenLevel(this.category)

    const obj = this.setCategoryData()
    if (!this.inModal) {
      this.setSelectedCategory(JSON.parse(JSON.stringify(obj)))
    }
  }
}
